import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import "../../styles/Login.css";
import logo from "../../assets/colored-logo.png";

import { loginApi, requestPasswordReset } from "../../lib/api";

export default function Login() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [resetMode, setResetMode] = useState(false);
  const [identifier, setIdentifier] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await loginApi(username, password);

      if (res.role === "admin") {
        navigate("/portal-admin/dashboard");
      } else {
        navigate("/dashboard");
      }
    } catch (err) {
      toast.error(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (!identifier.trim()) {
      toast.error("Enter your username or account email");
      return;
    }
    try {
      setLoading(true);
      const result = await requestPasswordReset(identifier);
      toast.success(result?.message || "If an account matches those details, a password email has been sent.");
      setResetMode(false);
      setIdentifier("");
    } catch (err) {
      toast.error(err?.message || "Unable to request a password reset");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-logo">
        <img src={logo} alt="Hindsight Sustainability" />
      </div>

      <form className="login-card" onSubmit={resetMode ? handlePasswordReset : handleSubmit}>
        <h1>{resetMode ? "Reset your password" : "Platform Login"}</h1>
        <p className="subtitle">{resetMode ? "Enter your username or account email and we will send a secure link." : "Sign in to access your workspace."}</p>

        {resetMode ? (
          <input
            type="text"
            placeholder="Username or account email"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
          />
        ) : (
          <>

            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />

            <div className="password-field">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </>
        )}

        <button
          type="submit"
          className="btn-primary"
          disabled={loading}
        >
          {loading ? "Please wait..." : resetMode ? "Send secure link" : "Sign In"}
        </button>
        <button type="button" className="login-link-button" onClick={() => setResetMode((current) => !current)} disabled={loading}>
          {resetMode ? "Return to sign in" : "Forgot password?"}
        </button>
      </form>
    </div>
  );
}
